module.exports = __webpack_public_path__ + "img/ZWF_Piotr_Zuzanna.0033f8b3.jpg";